import React from "react";
import "../css/dashboard.css";
import ClientsContent from "./ClientsContent";
import Navbar from "../component/Navbar";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ClientsContentMobile from "./ClientsContentMobile";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Clients() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  const isPhilippines = searchParams.get("rehab") === "ph";
  const rehabFilter = isPhilippines
    ? "miracles_asia_philippines"
    : "miracles_asia_thailand";
  const title = isPhilippines ? "All Client PH" : "All Client TH";
  const initialTab = searchParams.get("tab");

  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
          <MenuIcon />
        </IconButton>
      </div>

      <ClientsContentMobile
        title={title}
        rehabFilter={rehabFilter}
        initialTab={initialTab}
      />
    </>
  ) : (
    <>
      <Navbar linkActive={isPhilippines ? 22 : 1} />
      <ClientsContent
        title={title}
        rehabFilter={rehabFilter}
        initialTab={initialTab}
      />
    </>
  )}
</div>
  );
}
